import React from 'react';
import './CtaButton.scss';
// import contents from '../../contents';
// import ctaButtonImg from '../../Assets/ctaButtonImg.jpg';
// import ctaButtonArrow from '../../Assets/ctaButtonArrow.svg';

function CtaButton({ handleMouseLeaveTooltip, handleMouseEnterTooltip }) {
  // const ctaTooltip = useRef();
  return (
    <>
      <p className="cta">
        Learn more about BASF's sustainability initiatives{' '}
        <a
          href="https://www.basf.com/us/en/who-we-are/change-for-climate.html"
          target="_blank"
          rel="sponsored noopener"
        >
          here.
        </a>
      </p>
    </>
  );
}

export default CtaButton;
